import React from 'react'
import { AsyncSelect } from '_zari/core'
import * as UsuarioService from 'services/usuario.service'

const Select2UsuariosContabilidad = ({ id, disabled, onChange }) => {
  const loadUsuariosSelect = React.useCallback((inputValue, resolve) => {
    UsuarioService.obtenerUsuariosContabilidadxBusquedaAsSelect2({ busqueda: inputValue })
      .then(({ data }) => resolve(data)) // ⚡ el backend ya devuelve en formato Select2
      .catch(() => resolve([]))
  }, [])

  return (
    <AsyncSelect
      selectId={id}
      loadOptions={loadUsuariosSelect}
      onChange={onChange}
      isDisabled={disabled}
    />
  )
}

export default React.memo(Select2UsuariosContabilidad)
